import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { SanityTextPortraitSection } from 'graphql-types';
import React, { useState } from 'react';
import { findTranslation } from '../../utils/findTranslation';
import { usePageContext } from '../context/pageContext';
import { Blocks } from '../ui/blocks/Blocks';
import * as styles from './textPortraitSection.module.scss';

interface Props {
  section: SanityTextPortraitSection;
}

export const TextPortraitSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  return (
    <div
      className={`${section?.imgSection?.img?.asset?.extension !== 'jpg' && styles.wrappersvg} ${
        styles.wrapper
      }`}
    >
      {section?.activeImage && (
        <>
          {section?.imgSection?.img?.asset?.extension !== 'jpg' ? (
            <div className={styles.svg}>
              <GatsbyImage
                image={section?.imgSection?.img?.asset?.gatsbyImageData ?? ''}
                alt={section?.imgSection?.alt ?? ''}
              />
            </div>
          ) : (
            <div className={styles.image}>
              <GatsbyImage
                alt={section?.imgSection?.alt ?? ''}
                image={section?.imgSection?.img?.asset?.gatsbyImageData}
              />
            </div>
          )}
        </>
      )}
      <div className={`${styles.text} ${section?.align === 'center' && styles.center}`}>
        <Blocks blocks={findTranslation(section?._rawTextSection, lang, defaultLang)} />
      </div>
      {section?.activePerson && <p className={styles.person}>{section?.personSection}</p>}
      {section?.activeFunction && (
        <p className={styles.poste}>
          {findTranslation(section?._rawFunctionSection, lang, defaultLang)}
        </p>
      )}
    </div>
  );
};
